module.exports = __webpack_public_path__ + "static/media/hotbid-two.a50da0fa.png";